import { NewsQuestionsView } from './news-questions-view'
import { getTemplate } from 'helpers/template-helper'
import { Model } from 'es6/components/model'

export class NewsCommentsView extends NewsQuestionsView {
  /**
   * @inheritDoc
   */
  run () {
    this.answerField = 'message_reply'
    this.isFormRenderedOnInit = true
    this.replyTemplate = getTemplate('#news-comment-reply-template')
    this.noCommentsTemplate = getTemplate('#no-comments-template')
    this.answerTemplateSelector = '#news-comment-reply-template'
    super.run()
  }

  /**
   * @inheritDoc
   */
  renderQuestions () {
    super.renderQuestions()
    let totalCount = this.collection.state.totalCount,
      length = this.collection.length,
      perPage = this.collection.state.perPage
    let commentsQty = totalCount
    if (length > totalCount) {
      commentsQty = length
    } else if (length > perPage) {
      commentsQty += length - perPage
    }
    this.$('.comments-qty').html(commentsQty)
    const noComments = this.$('.comment.short')
    if (!commentsQty) {
      this.$('.js-question-form').prepend(this.noCommentsTemplate)
    } else if (noComments.length) {
      noComments.addClass('not_display')
    }
  }

  /**
   * Возвращает ответы переданной модели комментария.
   * @param {Model} model Модель.
   * @returns {string} Ответ.
   */
  resolveReplies (model) {
    return model instanceof Model ? model.get('message_reply') : ''
  }
}
